import { LAST_UPI_RATE } from "../api/constApi";
import { apiInstance } from "./axiosApi";

export const lastUpiRate = (payload) => {
  return apiInstance.get(LAST_UPI_RATE, payload);
};
